import React from "react";
import { styles } from "../styles/theme";

function LoginPage({ playerName, setPlayerName, handleJoin }) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Compra el Pan</h1>
        <p style={styles.subtitle}>
          Gana dinero con mini-juegos, compra el pan y decide cuánta ayuda se da a los
          que menos tienen.
        </p>
        <label style={styles.label}>Tu nombre</label>
        <input
          style={styles.input}
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          placeholder="Ej. Marco"
        />
        <button style={styles.button} onClick={handleJoin}>
          Entrar al juego
        </button>
      </div>
    </div>
  );
}

export default LoginPage;
